import { Button } from "../Button/index.js";
import React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { FormProvider, useForm } from "react-hook-form";
import { useGridFilter } from "ag-grid-react";
//#region src/TableFioFilter/TableFioFilter.tsx
const EMPTY_MODEL = {
	lastName: "",
	firstName: "",
	middleName: ""
};
const TableFioFilter = ({ colDef, api, model, onModelChange, rowFilter }) => {
	const methods = useForm({ defaultValues: model ?? EMPTY_MODEL });
	const [appliedValue, setAppliedValue] = React.useState(model);
	const value = methods.watch();
	const isFiltersEmpty = !value.lastName && !value.firstName && !value.middleName;
	const isInitialFiltersEmpty = !model?.lastName && !model?.firstName && !model?.middleName;
	const doesFilterPass = React.useCallback((node) => {
		if (!appliedValue || !appliedValue.lastName && !appliedValue.firstName && !appliedValue.middleName) return true;
		if (rowFilter) return rowFilter(appliedValue, node.data ?? {});
		const field = colDef.field;
		if (!field || !node.data) return true;
		const fioSource = String(node.data[field] ?? "").toLowerCase();
		const search = [
			appliedValue.lastName,
			appliedValue.firstName,
			appliedValue.middleName
		].filter(Boolean).join(" ").toLowerCase();
		if (!search) return true;
		return fioSource.includes(search);
	}, [
		appliedValue,
		colDef.field,
		rowFilter
	]);
	useGridFilter({ doesFilterPass });
	const handleApplyClick = () => {
		const currentValue = methods.getValues();
		const nextModel = Boolean(currentValue.lastName || currentValue.firstName || currentValue.middleName) ? currentValue : null;
		onModelChange(nextModel);
		setAppliedValue(nextModel);
		api.hideColumnFilter();
	};
	const handleResetClick = () => {
		methods.reset(EMPTY_MODEL);
		setAppliedValue(null);
		onModelChange(null);
		const columnKey = colDef.colId ?? colDef.field;
		if (columnKey) api.destroyFilter(columnKey);
		api.hideColumnFilter();
	};
	React.useEffect(() => {
		methods.reset(model ?? EMPTY_MODEL);
		setAppliedValue(model);
	}, [model, methods]);
	return /* @__PURE__ */ jsx(FormProvider, {
		...methods,
		children: /* @__PURE__ */ jsxs("div", {
			className: "bg-neutrals-white w-64 rounded-xl py-[0.3125rem] shadow",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "flex flex-col gap-3 px-2.5 py-1",
				children: [
					/* @__PURE__ */ jsxs("label", {
						className: "flex flex-col gap-1",
						children: [/* @__PURE__ */ jsx("span", {
							className: "text-type-light text-xs",
							children: "Фамилия"
						}), /* @__PURE__ */ jsx("input", {
							...methods.register("lastName"),
							placeholder: "Фамилия",
							className: "border-neutrals-80 text-type-common focus:border-system-info-70 h-8 rounded-lg border px-2 text-sm outline-none"
						})]
					}),
					/* @__PURE__ */ jsxs("label", {
						className: "flex flex-col gap-1",
						children: [/* @__PURE__ */ jsx("span", {
							className: "text-type-light text-xs",
							children: "Имя"
						}), /* @__PURE__ */ jsx("input", {
							...methods.register("firstName"),
							placeholder: "Имя",
							className: "border-neutrals-80 text-type-common focus:border-system-info-70 h-8 rounded-lg border px-2 text-sm outline-none"
						})]
					}),
					/* @__PURE__ */ jsxs("label", {
						className: "flex flex-col gap-1",
						children: [/* @__PURE__ */ jsx("span", {
							className: "text-type-light text-xs",
							children: "Отчество"
						}), /* @__PURE__ */ jsx("input", {
							...methods.register("middleName"),
							placeholder: "Отчество",
							className: "border-neutrals-80 text-type-common focus:border-system-info-70 h-8 rounded-lg border px-2 text-sm outline-none"
						})]
					})
				]
			}), /* @__PURE__ */ jsxs("div", {
				className: "flex flex-nowrap items-center gap-2 px-2.5 pb-1 pt-4",
				children: [/* @__PURE__ */ jsx(Button, {
					onClick: handleApplyClick,
					theme: "primary",
					size: "sm",
					className: "flex-1",
					type: "button",
					disabled: isInitialFiltersEmpty && isFiltersEmpty,
					children: "Применить"
				}), /* @__PURE__ */ jsx(Button, {
					onClick: handleResetClick,
					size: "sm",
					className: "flex-1",
					type: "button",
					children: "Сбросить"
				})]
			})]
		})
	});
};
//#endregion
export { TableFioFilter };

//# sourceMappingURL=TableFioFilter.js.map